import { render } from "./Portfolioview.vue?vue&type=template&id=7569f8b6"
import script from "./Portfolioview.vue?vue&type=script&lang=js"
export * from "./Portfolioview.vue?vue&type=script&lang=js"

import "./Portfolioview.vue?vue&type=style&index=0&id=7569f8b6&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__